
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HistoireHero from "@/components/histoire/HistoireHero";
import HistoireContent from "@/components/histoire/HistoireContent";
import HistoireTimeline from "@/components/histoire/HistoireTimeline";
import HistoireCTA from "@/components/histoire/HistoireCTA";

const Histoire = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow pt-20">
        <HistoireHero />
        <HistoireContent />
        <div className="container mx-auto px-4">
          <HistoireTimeline />
        </div>
        <HistoireCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Histoire;
